import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <Row>
          <Col className="text-center py-3">
            <p className="footer-text">© 2024 Your Company. All Rights Reserved.</p>
          </Col>
        </Row>
      </div>
    </footer>
  );
};

export default Footer;
